const UserType = Object.freeze({
  ADMIN: 'admin',
  MANAGER: 'manager',
} as const);

export type UserType = (typeof UserType)[keyof typeof UserType];

export default UserType;
